import React from 'react';
import { Box, Card, CardActionArea, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import InsightsIcon from '@mui/icons-material/Insights';

// Temporary: only enable these areas during local development. On any deployed
// host (e.g. https://admin.emmersongray.co.uk) they show but are disabled
// (greyed out, non-clickable); on localhost they remain available for testing.
const isLocalDev =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);

const TILES = [
  {
    to: '/devices',
    title: 'Device Admin',
    desc: 'Catalogue & pricing — the Miller-column device editor.',
    icon: <DevicesOtherIcon sx={{ fontSize: 48 }} color="primary" />,
  },
  {
    to: '/orders',
    title: 'Order Admin',
    desc: 'Import, track and process orders across Etsy, eBay, Shopify and direct.',
    icon: <ReceiptLongIcon sx={{ fontSize: 48 }} color="primary" />,
    devOnly: true,
  },
  {
    to: '/kpis',
    title: 'KPIs',
    desc: 'Charts & tables — sales and workshop metrics (coming soon).',
    icon: <InsightsIcon sx={{ fontSize: 48 }} color="primary" />,
    devOnly: true,
  },
];

/** Front-page menu linking to each admin area. */
export default function HomeMenu() {
  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1100, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>
        Admin
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Choose an area to work in.
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gap: 3,
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' },
        }}
      >
        {TILES.map((t) => {
          const disabled = t.devOnly && !isLocalDev;
          return (
            <Card key={t.to} variant="outlined" sx={{ opacity: disabled ? 0.5 : 1 }}>
              <CardActionArea
                component={disabled ? 'div' : RouterLink}
                to={disabled ? undefined : t.to}
                disabled={disabled}
                sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1.5 }}
              >
                {t.icon}
                <Typography variant="h6">{t.title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {t.desc}
                </Typography>
              </CardActionArea>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
}
